import React from "react";

import { ButtonStandard, ModalBase, Text } from "@performyard/py-components";

interface ArchiveModalProps {
	isOpen: boolean;
	competencyName: string;
	onConfirm: () => void;
	onClose: () => void;
}

const ArchiveModal = ({ isOpen, competencyName, onConfirm, onClose }: ArchiveModalProps) => {
	return (
		<ModalBase isOpen={isOpen} onClose={onClose}>
			<div className="box-border w-[432px] px-6 pb-6">
				<Text size="sub-heading" weight="semi-bold" dangerouslySetClassName="text-center">
					Archive Competency?
				</Text>
				<Text size="paragraph-1" dangerouslySetClassName="mt-4 text-center">
					Are you sure you want to archive the competency &quot;{competencyName}&quot;?
				</Text>
				<div className="mt-6 flex justify-center gap-2">
					<div>
						<ButtonStandard size="large" variant="outline" color="neutral" onClick={onClose}>
							Cancel
						</ButtonStandard>
					</div>
					<div>
						<ButtonStandard size="large" color="primary" onClick={onConfirm}>
							Yes, Archive Competency
						</ButtonStandard>
					</div>
				</div>
			</div>
		</ModalBase>
	);
};

export default ArchiveModal;
